/* jshint esversion: 6 */
import React, { useState, useEffect } from 'react';
import CalendarEvent from 'app/components/Queue/CalendarComponents/CalendarEvent.jsx';
import { useCurrentBreakpointName } from 'react-socks';
import Utilities from 'app/utility/Utilities.js';

const CalendarCell = (props) => {
    const [ addActive, setAddActive ] = useState(false);

    useEffect(() => {
        let [row, column] = props.activeCell;

        if ((row !== props.row || column !== props.column) && addActive) {
            setAddActive(false);
        }
    }, [props.activeCell]);

    const toggleAdd = (e) => {
        e.preventDefault();
        let nextAddActive = (addActive) ? false : true;

        if (nextAddActive) {
            if (props.cellDate <= props.today) {
                return;
            }
        }
        setAddActive(nextAddActive);
        props.setActiveCell([props.row, props.column]);

    }

    const addScheduledPost = (e) => {
        e.preventDefault();
        e.stopPropagation();

        // a week's cell is an hour of its day, a month's the whole day
        props.persistData('scheduleDate', JSON.stringify({
            date: props.cellDate.toDate(),
            hasHour: props.cellHour !== null,
            source: encodeURIComponent(window.location.href)
        }));
        if (props.social && props.social.id) {
            props.router.navigate(`/content/post?id=${props.social.id}`);
        } else {
            props.router.navigate(`/content/post`);
        }
    }

    const openDrawer = (e) => {
        e.preventDefault();
        e.stopPropagation();

        props.showDrawer(true, null, props.cellDate)
    };

    let eventDisplay = null,
        seeMore = null,
        cellEvents = Utilities.deepClone(props.cellEvents);

    if (props.currentView === 'month' && useCurrentBreakpointName() === 'desktop') {
        if (cellEvents.length > 4) {
            let moreCount = cellEvents.length - 4;
            seeMore = (
                <div className="more-events-link" role="button" aria-label="see all events" onClick={(e) => {
                    props.showDrawer(true, null, props.cellDate);
                }}>
                    +{moreCount}
                </div>
            );
            cellEvents = cellEvents.slice(0, 4);
        }
        eventDisplay = (
            <div>
                {cellEvents.map((event, k) => {
                    return(
                        <CalendarEvent
                            key={`event-${props.row}-${props.column}-${k}`}
                            {...props}
                            event={event}/>
                    );
                })}
            </div>
        );

    } else if (props.currentView === 'month' && useCurrentBreakpointName() === 'mobile') {
        if (cellEvents.length) {
            eventDisplay = (
                <div className="mobile-dot-container" data-date={props.cellDate.format("YYYY-MM-DD")} onClick={openDrawer} onTouchEnd={openDrawer}>
                    {cellEvents.length}
                </div>
            );
        }
    } else if (props.currentView === 'week') {
        eventDisplay = (
            <div>
                {cellEvents.map((event, k) => {
                    return(
                        <CalendarEvent
                            key={`event-${props.row}-${props.column}-${k}`}
                            {...props}
                            event={event}/>
                    );
                })}
            </div>
        );
    }

    let addPost = null;
    // if (useCurrentBreakpointName() === 'mobile' || props.currentView === 'week') {
    //     addPost = <span className="date-spacer"></span>
    // }
    if (addActive) {
        addPost = (
            <div className="add-post-button" role="button" aria-label="Add Scheduled Post" onClick={addScheduledPost} onTouchEnd={addScheduledPost}>
                <i className="ion-android-add-circle"/>
            </div>
        );
    }

    let dateDisplay = null;
    if (props.showCellHeader) {
        if (props.currentView === 'month') {
            dateDisplay = (
                <div className="date-display">
                    {props.cellDate.format('D')}
                </div>
            );
        } else if (props.currentView === 'week') {
            dateDisplay = (
                <div className="date-display">
                    {props.cellDate.format('h a')}
                </div>
            );
        }
    } else if (!props.showCellHeader && props.currentView === 'week') {
        dateDisplay = (
            <div className="date-spacer"></div>
        );
    }

    return (
        <div className="cell-content"
            onTouchEnd={toggleAdd}
            onMouseOver={(e) => {
                let unit = (props.currentView === 'month') ? 'day' : 'hour';

                if (props.today.isAfter(props.cellDate, unit)) {
                    return;
                }

                setAddActive(true);
            }}
            onMouseOut={() => {
                let unit = (props.currentView === 'month') ? 'day' : 'hour';

                if (props.today.isAfter(props.cellDate, unit)) {
                    return;
                }

                setAddActive(false);
            }}
            data-date={props.cellDate.format('YYYY-MM-DD')}
            data-hour={props.cellHour}
            data-pw={props.currentView === 'week' ? `hour ${props.cellDate.format('YYYY-MM-DD')} ${props.cellHour}` : `day ${props.cellDate.format('YYYY-MM-DD')}`}>
            <div className="date-container">
                {dateDisplay}
                {addPost}
            </div>
            <div className="cell-data">
                {eventDisplay}
                {seeMore}
            </div>
        </div>
    );
};

export default CalendarCell;
